module.exports = "<b style=\"font-size:120%;width:2rem;line-height:2rem;display:block;text-align:center;border-radius:3px;color:#ffffff\"\r\n    title=\"{{$ctrl.nominasStatus[$ctrl.status]}}\"\r\n    ng-style=\"{background: $ctrl.nominasColores[$ctrl.status]}\">\r\n  {{$ctrl.status}}\r\n</b>\r\n<small><b>{{$ctrl.nominasTipo[$ctrl.idTipoNomina]}}</b></small>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/nominas/nomina/components/status/template.html
// module id = 1411
// module chunks = 0